/** @format */

import React, { useState, useEffect } from "react";
import {
  Text,
  Textarea,
  Select,
  TextInput,
  SegmentedControl,
  Divider,
} from "@mantine/core";
import { camelCaseToTitle } from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  businessUnitDetails,
  getAgreementDetails,
  getOrgDetails,
  getuserMail,
} from "../../utilities/apis/agreements";
import flat from "flat";
import { getUserRolesUsingRoleId } from "../../utilities/apis/serviceProvider";
import {
  getBuDetails,
  getOrgDetailsFromMaster,
} from "../../utilities/apis/users";

const AgreementParty = ({
  agreementFormJson,
  partyName,
  dropDownNames,
  setDropDownNames,
  form,
  setName,
  dataRole,
  setDataRole,
}) => {
  if (!agreementFormJson[partyName].type) {
    agreementFormJson[partyName].type = "Entity";
  }
  const [budetails, setBudetails] = useState(null);
  const [userRolesIdData, setUserRolesIdData] = useState({
    userRoles: {
      SigningAuthority: [],
    },
  });

  const isFirstParty = partyName === "firstParty";

  const fieldStyles = {
    input: {
      height: 44,
    },
    label: {
      fontWeight: 500,
      marginBottom: 6,
    },
    error: {
      fontSize: 12,
      textTransform: "none",
    },
  };

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const roles = {
          SigningAuthority: (
            await apiWrapWithErrorWithData(getUserRolesUsingRoleId(7))
          ).result,
        };

        setUserRolesIdData((prevData) => ({
          ...prevData,
          userRoles: roles,
        }));
      } catch (error) {
        console.error("Error fetching user roles:", error);
      } finally {
        console.log("final");
      }
    };

    fetchUserRoles();
  }, []);

  const bu = form.values["businessUnit"];
  console.log("buid: ", bu);
  const budetailsfetch = async () => {
    const response = await apiWrapWithErrorWithData(
      getBuDetails({ id: parseInt(bu) }),
    );
    // console.log(response);
    if (response.success) {
      setBudetails(response.result[0].details);
    } else {
      console.log("error accured in fetching bu details");
    }
  };

  useEffect(() => {
    budetailsfetch();
  }, [bu]);
  // console.log("budetails: ", budetails);
  console.log("form: ", form.values);
  const type = agreementFormJson[partyName].type || "Entity";
  // console.log("type of sanjf: ", type);

  const [phone, setPhone] = useState("");

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Allow only up to 10 digits
    if (value.length <= 10 && /^\d*$/.test(value)) {
      setPhone(value);
      // Update the form state only for a complete 10-digit number
      if (value.length === 10) {
        form.setValue(`${partyName}.phone`, value);
      }
    }
  };
  const [orgDetails, setOrgDetails] = useState({
    address: "",
    name: "",
    entityType: "Company",
    brandName: "",
    corporateAddress: "",
    email: "",
    representative: "",
  });
  useEffect(() => {
    const getOrganizationDetails = async () => {
      const resp = await apiWrapWithErrorWithData(getOrgDetailsFromMaster());
      if (resp.success) {
        setOrgDetails({
          address: resp.result[0].details["regAddress"] || "",
          entityType: resp.result[0].details["entityType"] || "",
          name: resp.result[0]["name"] || "",
          brandName: resp.result[0].details?.brandName || "",
        });
      }
    };
    getOrganizationDetails();
  }, []);
  useEffect(() => {
    if (partyName === "firstParty" && orgDetails) {
      form.setValues((prevValues) => {
        const currentValues = flat.unflatten(prevValues);

        // Check if firstParty.name exists
        if (!currentValues.firstParty?.name) {
          const newValues = {
            ...currentValues,
            firstParty: {
              address: orgDetails.address,
              brandName: orgDetails.brandName,
              corporateAddress: orgDetails.corporateAddress,
              email: orgDetails.signEmail,
              entityType: orgDetails.entityType,
              name: orgDetails.name,
              representative: orgDetails.poc,
              type: "Entity",
            },
          };
          return flat(newValues);
        }

        return prevValues;
      });
    }
  }, [budetails, orgDetails, partyName]);
  const getMail = async ({ id }) => {
    console.log("Getting mail for user ID:", id);

    // Check if id is valid
    if (!id) {
      console.error("getMail: ID is null or undefined");
      return null;
    }

    try {
      const resp = await apiWrapWithErrorWithData(getuserMail({ id }));
      if (resp.success) {
        return resp.email;
      } else {
        console.error("getMail: API returned error:", resp);
        return null;
      }
    } catch (error) {
      console.error("getMail: Exception occurred:", error);
      return null;
    }
  };
  // Debugging: Log the current phone state and form state value
  // console.log("Local phone state:", phone);
  // console.log("Form state for phone:", form.values[`${partyName}.phone`]);
  // const [type, setType] = useState("Entity");

  return (
    <div className="flex flex-col">
      <div
        className="flex justify-between items-center mb-6"
        style={{
          paddingBottom: 12,
          borderBottom: "1px solid #E9ECEF",
        }}
      >
        <Text fw={600} fz="lg" c="blue">
          {camelCaseToTitle(partyName)}
        </Text>
        <SegmentedControl
          radius="md"
          color="blue"
          size="md"
          {...form.getInputProps(`${partyName}.type`)}
          color="primary"
          data={["Entity", "Individual"]}
        />
      </div>
      <div
        className="grid grid grid-cols-1
                  lg:grid-cols-2
                  xl:grid-cols-3
                  gap-x-8
                  gap-y-6"
      >
        {type === "Entity" && (
          <>
            <Select
              size="md"
              radius="md"
              styles={fieldStyles}
              required
              className="inputCustom "
              label="Entity Type"
              style={{ width: "100%", marginLeft: "0px", lineHeight: "1.55" }}
              data={[
                { value: "Company", label: "Company" },
                { value: "LLP", label: "LLP" },
                { value: "Partnership Firm", label: "Partnership Firm" },
                { value: "Sole Proprietary", label: "Sole Proprietary" },
              ]}
              disabled={isFirstParty}
              {...form.getInputProps(`${partyName}.entityType`)}
              placeholder="Select Entity Type"
              error={form.errors[`${partyName}.entityType`]}
            />
            {partyName !== "firstParty" ? (
              <Select
                size="md"
                radius="md"
                styles={fieldStyles}
                required
                searchable
                creatable
                className="inputCustom "
                label="Registered Name"
                // onChange={(e)=> setName(e.target.value)}
                placeholder="Enter Registered Name"
                data={[...dropDownNames]}
                getCreateLabel={(query) => `+ add ${query}`}
                onCreate={(query) => {
                  setDropDownNames([...dropDownNames, query]);
                }}
                {...form.getInputProps(`${partyName}.name`)}
                style={{
                  width: "100%",
                  marginLeft: "0px",
                  margin: "0px",
                  padding: "0px",
                  lineHeight: "1.55",
                }}
                error={form.errors[`${partyName}.name`]}
              />
            ) : (
              <TextInput
                size="md"
                radius="md"
                styles={fieldStyles}
                required
                label="Registered Name"
                placeholder="Enter Registered Name"
                readOnly={isFirstParty}
                {...form.getInputProps(`${partyName}.name`)}
                error={form.errors[`${partyName}.name`]}
              />
            )}
            <TextInput
              size="md"
              radius="md"
              styles={fieldStyles}
              label="Brand Name"
              placeholder="Enter Brand Name"
              readOnly={isFirstParty}
              {...form.getInputProps(`${partyName}.brandName`)}
              error={form.errors[`${partyName}.brandName`]}
            />
            {partyName === "firstParty" ? (
              <>
                <Select
                  size="md"
                  radius="md"
                  styles={fieldStyles}
                  // key="SigningAuthority"
                  label="Signing Authority"
                  placeholder="Select Signing Authority"
                  value={dataRole["7"]?.[0]?.userId || null}
                  // value={dataRole["7"][0]?.userId || null}
                  onChange={async (selectedUser) => {
                    setDataRole({
                      ...dataRole,
                      ["7"]: [
                        {
                          userId: selectedUser,
                          isComplete: false,
                        },
                      ],
                    });
                    const selectedUserLabel =
                      userRolesIdData.userRoles.SigningAuthority.find(
                        (user) => user.id === selectedUser,
                      )?.name;
                    form.setFieldValue(
                      `${partyName}.signatory`,
                      selectedUserLabel,
                    );
                    form.setFieldValue(
                      `${partyName}.email`,
                      await getMail({ id: selectedUser }),
                    );
                    // Clear any existing error when a value is selected
                    form.clearFieldError(`${partyName}.signingAuthority`);
                  }}
                  data={userRolesIdData.userRoles.SigningAuthority.map(
                    (user) => ({
                      value: user.id,
                      label: user.name,
                    }),
                  )}
                  required
                  error={form.errors[`${partyName}.signingAuthority`]}
                />
              </>
            ) : (
              <>
                <TextInput
                  size="md"
                  radius="md"
                  styles={fieldStyles}
                  required
                  label="Authorised Signatory Name"
                  placeholder="Enter Authorised Signatory Name"
                  {...form.getInputProps(`${partyName}.signatory`)}
                  error={form.errors[`${partyName}.signatory`]}
                />
                <TextInput
                  size="md"
                  radius="md"
                  styles={fieldStyles}
                  required
                  label="Authorised Signatory Email Address"
                  placeholder="Enter Authorised Signatory Email Address"
                  {...form.getInputProps(`${partyName}.email`)}
                  error={form.errors[`${partyName}.email`]}
                />
              </>
            )}
            <TextInput
              size="md"
              radius="md"
              styles={fieldStyles}
              label="Business POC"
              placeholder="Enter Business POC"
              readOnly={isFirstParty}
              {...form.getInputProps(`${partyName}.representative`)}
              error={form.errors[`${partyName}.representative`]}
            />
            <TextInput
              size="md"
              radius="md"
              styles={fieldStyles}
              label="Business POC Email Address"
              placeholder="Enter Business POC Email Address"
              readOnly={isFirstParty}
              {...form.getInputProps(`${partyName}.pocemail`)}
              error={form.errors[`${partyName}.pocemail`]}
            />
            {/* {partyName === "firstParty" && <div></div>} */}
            <Textarea
              size="md"
              radius="md"
              styles={fieldStyles}
              minRows={3}
              autosize
              label="Registered Address"
              placeholder="Enter Registered Address"
              readOnly={isFirstParty}
              {...form.getInputProps(`${partyName}.address`)}
              error={form.errors[`${partyName}.address`]}
            />
            <Textarea
              size="md"
              radius="md"
              styles={fieldStyles}
              minRows={3}
              autosize
              label="Corporate Address"
              placeholder="Enter Corporate Address"
              readOnly={isFirstParty}
              {...form.getInputProps(`${partyName}.corporateAddress`)}
              error={form.errors[`${partyName}.corporateAddress`]}
            />
          </>
        )}
        {type === "Individual" && (
          <>
            <TextInput
              size="md"
              radius="md"
              styles={fieldStyles}
              required
              label="Individual Name"
              placeholder="Enter Individual Name"
              {...form.getInputProps(`${partyName}.indi_name`)}
              error={form.errors[`${partyName}.indi_name`]}
            />
            <TextInput
              size="md"
              radius="md"
              styles={fieldStyles}
              label="Father's Name"
              placeholder="Enter Father's Name"
              {...form.getInputProps(`${partyName}.indi_fatherName`)}
              error={form.errors[`${partyName}.indi_fatherName`]}
            />
            <TextInput
              size="md"
              radius="md"
              styles={fieldStyles}
              label="PAN Number"
              placeholder="Enter PAN Number"
              {...form.getInputProps(`${partyName}.indi_pan`)}
              error={form.errors[`${partyName}.indi_pan`]}
            />
            <TextInput
              size="md"
              radius="md"
              styles={fieldStyles}
              required
              label="Email Address"
              placeholder="Enter Email Address"
              {...form.getInputProps(`${partyName}.indi_email`)}
              error={form.errors[`${partyName}.indi_email`]}
            />
            <TextInput
              size="md"
              radius="md"
              styles={fieldStyles}
              label="Phone Number"
              placeholder="Enter 10 Digit Phone Number"
              value={phone}
              onChange={handlePhoneChange}
              {...form.getInputProps(`${partyName}.indi_phone`)}
              error={form.errors[`${partyName}.indi_phone`]}
            />
            <Textarea
              size="md"
              radius="md"
              styles={fieldStyles}
              minRows={3}
              autosize
              label="Residential Address"
              placeholder="Enter Residential Address"
              {...form.getInputProps(`${partyName}.indi_address`)}
              error={form.errors[`${partyName}.indi_address`]}
            />
          </>
        )}
      </div>
      <Divider my="xl" />
    </div>
  );
};

export default AgreementParty;
